module.exports = __webpack_public_path__ + "img/tcm-resources.55a38675.png";